import Input from './Input';

export default Input;



// WEBPACK FOOTER //
// ./src/client/Components/Forms/Input/index.js